import React from 'react';
import { Field, useFormikContext } from 'formik';
import {
    FormControl,
    FormControlLabel,
    FormHelperText,
    Radio,
    RadioGroup as MUIRadioGroup,
    RadioGroupProps,
} from '@mui/material';
import { GenericObject } from '@fnol/library/src/lib';
import { legalPersonType, personType, translations } from '../../lib/consts';

export type LegalIndividualSelectorProps = {
    id?: string;
    idIndividual?: string;
    idLegal?: string;
    selectorType: personType;
    onChange?: () => void;
};

const LegalIndividualSelector = ({ idIndividual, idLegal, selectorType, onChange }: LegalIndividualSelectorProps) => {
    const { errors, touched, setFieldValue } = useFormikContext<GenericObject>();

    const type = `${personType[selectorType]}Type`;
    const onSelectPersonType = (e: { target: { value: any } }) => {
        if (onChange) {
            onChange();
        }
        setFieldValue(type, e.target.value);
    };

    const RadioGroup = (params: RadioGroupProps) => {
        return (
            <MUIRadioGroup {...params} row sx={{ marginTop: '-15px' }}>
                <FormControlLabel
                    id={idIndividual}
                    value={legalPersonType.individual}
                    control={<Radio />}
                    label={translations.legalPersonType.INDIVIDUAL}
                />
                <FormControlLabel
                    id={idLegal}
                    value={legalPersonType.legal}
                    control={<Radio />}
                    label={translations.legalPersonType.LEGAL}
                />
            </MUIRadioGroup>
        );
    };

    return (
        <>
            <FormControl required={true}>
                <Field name={type} id={type} as={RadioGroup} size="big" onChange={onSelectPersonType} />

                {touched[type] && errors[type] ? (
                    <FormHelperText error={true}>
                        <>{errors[type]}</>
                    </FormHelperText>
                ) : null}
            </FormControl>
        </>
    );
};

export default LegalIndividualSelector;
